const atcTypes = Object.freeze({
    cart: 'cart',
    compare: 'compare',
    wishlist: 'wishlist',
})

export { atcTypes }
